import { Anchor, ITableCellProps, TableCell } from 'telia-front-react';
import React from 'react';

import { isHtml } from '../../util/TextUtil';

export const formatTableCellValue = (value: string) => {
  if (!value) {
    return '';
  }
  if (value.startsWith('http')) {
    return (
      <Anchor url={value} isUnderlined={false} target={'_blank'}>
        {value}
      </Anchor>
    );
  }
  if (isHtml(value)) {
    return <span dangerouslySetInnerHTML={{ __html: value }} />;
  }
  if (value.includes('\n')) {
    return <div style={{ whiteSpace: 'pre-line' }}>{value}</div>;
  }
  return value;
};

export const renderSpecialInformationMobileTableRow = (key: string, index: number, information: { [key: string]: string }): JSX.Element => (
  <tbody key={key}>
    {Object.keys(information).map(
      (rowName) =>
        !!information[rowName] && (
          <tr key={`${key}-${rowName}`} style={index % 2 !== 0 ? { backgroundColor: '#F4F4F9' } : undefined}>
            <TableCell>{rowName}</TableCell>
            <TableCell className="text-break">{formatTableCellValue(information[rowName])}</TableCell>
          </tr>
        )
    )}
  </tbody>
);

export const renderSpecialInformationDesktopTableHeading = (
  key: string,
  columns: string[],
  columnWidth: ITableCellProps['width'] | ITableCellProps['width'][]
): JSX.Element => (
  <tr>
    {columns.map((column, i) => (
      <TableCell key={`${key}-column-${i}`} width={Array.isArray(columnWidth) ? columnWidth[i] : columnWidth} type="th" scope="col">
        {column}
      </TableCell>
    ))}
  </tr>
);

export const renderSpecialInformationDesktopTableRow = (
  key: string,
  columns: { [key: string]: string },
  columnWidth: ITableCellProps['width'] | ITableCellProps['width'][]
): JSX.Element => (
  <tr key={key}>
    {Object.keys(columns).map((column, i) => (
      <TableCell key={`${key}-cell-${i}`} width={Array.isArray(columnWidth) ? columnWidth[i] : columnWidth} className="text-break">
        {formatTableCellValue(columns[column])}
      </TableCell>
    ))}
  </tr>
);
